import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { LaunchPage, MessageTooltip, Spacer, TextCapitalized } from "@qivia/ui";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  loadCompanyPortalUrlAsync,
  selectCompanyPortalUrlStatus,
} from "../billingsSlice";
import { selectCompany } from "../../homeSlice";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { EmailsFrame } from "../archives/statementsTab";

export const BillingCompanyPortal = (props: {
  companyPortalUrl: URL | null;
}) => {
  const { t } = useTranslation();
  const params = useParams();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const companyPortalUrlStatus = useAppSelector(selectCompanyPortalUrlStatus);

  useEffect(() => {
    if (company && companyPortalUrlStatus === "idle") {
      void dispatch(loadCompanyPortalUrlAsync(company?.uuid));
    }
  }, [company, companyPortalUrlStatus, dispatch]);

  if (params.tab !== "portal") {
    return;
  }

  if (!company) {
    return;
  }

  if (companyPortalUrlStatus === "processing") {
    return <LaunchPage />;
  }

  const getUrlStringified = (url: URL) => {
    url.searchParams.set("hideSidebar", "true");
    return url.toString();
  };

  return (
    <StyledCustomPortalSection>
      <Spacer y={0.5} />
      <MessageTooltip
        title={t("billings.portal.messageTooltip.title")}
        text={t("billings.portal.messageTooltip.text")}
        type="INFORMATIVE"
      />
      <Spacer y={1} />
      <EmailsFrame company={company} />
      <Spacer y={2} />
      {props.companyPortalUrl ? (
        <StyledPortalIframeContainer>
          <iframe
            title={t("billings.portal.link")}
            src={getUrlStringified(props.companyPortalUrl)}
          />
        </StyledPortalIframeContainer>
      ) : (
        <TextCapitalized>{t("billings.portal.unavailable")}</TextCapitalized>
      )}
    </StyledCustomPortalSection>
  );
};

const StyledPortalIframeContainer = styled.div`
  iframe {
    border-radius: 0.5rem;
    border: none;
    width: 100%;
    min-height: 35rem;
  }
`;

const StyledCustomPortalSection = styled.div`
  border-radius: 0.5rem;
`;
